import { Action } from '@ngrx/store';
export enum EPOActions {
    //purchase orders
      GetPONumber = '[PurchaseOrders] Get InternalCode of PO',
      GetPONumberSuccess = '[PurchaseOrders] Set PO InternalCode Success',
      GetPONumberError = '[PurchaseOrders] Set PO InternalCode Error',
      GetAllPOs = '[purchaseOrders] Get All POs',
      GetAllPOsSuccess = '[purchaseOrders] Get All POs Success',
      GetAllPOsError = '[] Get All POs Error',
      GetPOsByStatusId = '[purchaseOrders] Get POs By StatusId',
      GetPOsByStatusIdSuccess = '[purchaseOrders] Get POs By StatusId Success',
      GetPOsByStatusIdError = '[] Get POs By StatusId Error',
      AddPO = '[purchaseOrders] Add PO',
      GetAddPOSuccess = '[purchaseOrders] Add PO Success',
      GetAddPOError = '[] Get Add PO Error',
      EditPO = '[purchaseOrders] Edit PO',
      GetEditPOSuccess = '[purchaseOrders] Edit PO Success',
      GetEditPOError = '[] Get Edit PO Error',
      InActivatePO = '[purchaseOrders] InActivate PO',
      GetInActivatePOSuccess = '[purchaseOrders] Get InActivate PO Success',
      GetInActivatePOError = '[] Get InActivate PO Error',

      StatusMoveToComplete = '[POMaterials] Status move to Complete',
      GetStatusMoveToCompleteSuccess = '[POMaterials] Status move to Complete Success',
      GetStatusMoveToCompleteError = '[] Status move to Complete Error',

      GetReceiveMaterialCode = '[ReceiveMaterial] Get ReceiveMaterial InternalCode',
      GetReceiveMaterialCodeSuccess = '[ReceiveMaterial] Set ReceiveMaterial InternalCode Success',
      GetReceiveMaterialCodeError = '[ReceiveMaterial] Set ReceiveMaterial InternalCode Error',
      AddReceiveMaterial = '[purchaseOrders] Add Receive material',
      GetAddReceiveMaterialSuccess = '[purchaseOrders] Add Receive material Success',
      GetAddReceiveMaterialError = '[] Add Receive material Error',
      GetAllReceivedLOTs = '[purchaseOrders] Get All Receive Lots',
      GetAllReceivedLOTsSuccess = '[purchaseOrders] Get All Receive Lots Success',
      GetAllReceivedLOTsError = '[] Get All Receive Lots Error',
      EditReceivedLOTs = '[purchaseOrders] Edit Receive Lots',
      GetEditReceivedLOTsSuccess = '[purchaseOrders] Get Edit Receive Lots Success',
      GetEditReceivedLOTsError = '[] Get Edit Receive Lots Error',
  
      GetPodetailsById = '[purchaseOrders] Get PO Details By Id',
      GetPodetailsByIdSuccess = '[purchaseOrders] Get PO Details By Id Success',
      GetPodetailsByIdError = '[] Get PO Details By Id Error',

      GetAllVehicleCondition = '[purchaseOrders] Get All Vehicle Condition',
      GetVehicleConditionSuccess = '[purchaseOrders] Get Vehicle Condition Success',
      GetVehicleConditionError = '[] Get Vehicle Condition Error',

      GetCompletePO = '[purchaseOrders] Get Complete PO',
      GetCompletePOSuccess = '[purchaseOrders] Get Complete PO Success',
      GetCompletePOError = '[] Get Complete PO Error',
      GetPOsByAgentManuId='[purchaseOrders] Get PO By AgentManu Id',
      GetPOsByAgentManuIdSuccess='[purchaseOrders] Get PO By AgentManu Id Success',
      GetPOsByAgentManuIdError='[purchaseOrders] Get PO By AgentManu Id Error'
 }
    //puchase orders
        export class GetPONumber implements Action {
          public readonly type = EPOActions.GetPONumber;
          constructor(public payload: any) {
          }
        }
        export class GetPONumberSuccess implements Action {
          public readonly type = EPOActions.GetPONumberSuccess;
          constructor(public payload: any) {
          }
        }
        export class GetPONumberError implements Action {
          public readonly type = EPOActions.GetPONumberError;
          constructor(public payload: any) {
          }
        }
        export class GetAllPOs implements Action {
          public readonly type = EPOActions.GetAllPOs;
          constructor(public payload: any) {
          }
        }
        export class GetAllPOsSuccess implements Action {
          public readonly type = EPOActions.GetAllPOsSuccess;
          constructor(public payload: any) {
          }
        }
        export class GetAllPOsError implements Action {
          public readonly type = EPOActions.GetAllPOsError;
          constructor(public payload: any) {
          }
        }
        export class GetPOsByStatusId implements Action {
          public readonly type = EPOActions.GetPOsByStatusId;
          constructor(public payload: any) {
          }
        }
        export class GetPOsByStatusIdSuccess implements Action {
          public readonly type = EPOActions.GetPOsByStatusIdSuccess;
          constructor(public payload: any) {
          }
        }
        export class GetPOsByStatusIdError implements Action {
          public readonly type = EPOActions.GetPOsByStatusIdError;
          constructor(public payload: any) {
          }
        }
        export class EditPO implements Action {
          public readonly type = EPOActions.EditPO;
          constructor(public payload: any) {}
        }
        export class GetEditPOSuccess implements Action {
          public readonly type = EPOActions.GetEditPOSuccess;
          constructor(public payload: any) {}
        }
        export class GetEditPOError implements Action {
          public readonly type = EPOActions.GetEditPOError;
          constructor(public payload: any) {}
        }
        export class InActivatePO implements Action {
          public readonly type = EPOActions.InActivatePO;
          constructor(public payload: any ,public param : any) {}
        }
        export class GetInActivatePOSuccess implements Action {
          public readonly type = EPOActions.GetInActivatePOSuccess;
          constructor(public payload: any) {}
        }
        export class GetInActivatePOError implements Action {
          public readonly type = EPOActions.GetInActivatePOError;
          constructor(public payload: any) {}
        }

        export class AddPO implements Action {
          public readonly type = EPOActions.AddPO;
          constructor(public payload: any) {}
        }
        export class GetAddPOSuccess implements Action {
          public readonly type = EPOActions.GetAddPOSuccess;
          constructor(public payload: any) {}
        }
        export class GetAddPOError implements Action {
          public readonly type = EPOActions.GetAddPOError;
          constructor(public payload: any) {}
        }
        export class GetReceiveMaterialCode implements Action {
          public readonly type = EPOActions.GetReceiveMaterialCode;
          constructor(public payload: any) {}
        }
        export class GetReceiveMaterialCodeSuccess implements Action {
          public readonly type = EPOActions.GetReceiveMaterialCodeSuccess;
          constructor(public payload: any) {}
        }
        export class GetReceiveMaterialCodeError implements Action {
          public readonly type = EPOActions.GetReceiveMaterialCodeError;
          constructor(public payload: any) {}
        }
        export class AddReceiveMaterial implements Action {
          public readonly type = EPOActions.AddReceiveMaterial;
          constructor(public payload: any) {}
        }
       export class GetAddReceiveMaterialSuccess implements Action {
          public readonly type = EPOActions.GetAddReceiveMaterialSuccess;
          constructor(public payload: any) {}
        }
        export class  GetAddReceiveMaterialError implements Action {
          public readonly type = EPOActions. GetAddReceiveMaterialError;
          constructor(public payload: any) {}
        }
        export class GetAllReceivedLOTs implements Action {
          public readonly type = EPOActions.GetAllReceivedLOTs ;
          constructor(public payload: any) {}
        }
        export class  GetAllReceivedLOTsSuccess implements Action {
          public readonly type = EPOActions.GetAllReceivedLOTsSuccess ;
          constructor(public payload: any) {}
        }
        export class  GetAllReceivedLOTsError implements Action {
          public readonly type = EPOActions.GetAllReceivedLOTsError ;
          constructor(public payload: any) {}
        }
        export class EditReceivedLOTs implements Action {
          public readonly type = EPOActions.EditReceivedLOTs ;
          constructor(public payload: any) {}
        }
        export class GetEditReceivedLOTsSuccess implements Action {
          public readonly type = EPOActions.GetEditReceivedLOTsSuccess ;
          constructor(public payload: any) {}
        }
        export class  GetEditReceivedLOTsError implements Action {
          public readonly type = EPOActions.GetEditReceivedLOTsError ;
          constructor(public payload: any) {}
        }
  
        export class GetPodetailsById implements Action {
          public readonly type = EPOActions.GetPodetailsById ;
          constructor(public payload: any) {}
        }
        export class GetPodetailsByIdSuccess implements Action {
          public readonly type = EPOActions.GetPodetailsByIdSuccess ;
          constructor(public payload: any) {}
        }
        export class  GetPodetailsByIdError implements Action {
          public readonly type = EPOActions.GetPodetailsByIdError ;
          constructor(public payload: any) {}
        }

        export class GetAllVehicleCondition implements Action {
          public readonly type = EPOActions.GetAllVehicleCondition;
          constructor() {}
      }
      export class GetVehicleConditionSuccess implements Action {
          public readonly type = EPOActions.GetVehicleConditionSuccess;
          constructor(public payload: any) {}
      }
      export class GetVehicleConditionError implements Action {
          public readonly type = EPOActions.GetVehicleConditionError;
          constructor(public payload: any) {}
      }
      export class StatusMoveToComplete implements Action {
        public readonly type = EPOActions.StatusMoveToComplete;
        constructor(public payload: any ) {}
      }
      export class GetStatusMoveToCompleteSuccess implements Action {
        public readonly type = EPOActions.GetStatusMoveToCompleteSuccess;
        constructor(public payload: any ) {}
      }
      export class GetStatusMoveToCompleteError implements Action {
        public readonly type = EPOActions.GetStatusMoveToCompleteError;
        constructor(public payload: any ) {}
      }

      export class GetCompletePO implements Action {
        public readonly type = EPOActions.GetCompletePO;
        constructor(public payload: any, public param: any ) {
          console.log(payload);
          console.log(param);
        }
      }
      export class GetCompletePOSuccess implements Action {
        public readonly type = EPOActions.GetCompletePOSuccess;
        constructor(public payload: any) {
          console.log(payload);
        }
      }
      export class GetCompletePOError implements Action {
        public readonly type = EPOActions.GetCompletePOError;
        constructor(public payload: any) {

        }
        
      } export class GetPOsByAgentManuIdSuccess implements Action {
        public readonly type = EPOActions.GetPOsByAgentManuIdSuccess;
        constructor(public payload: any) {

        }
        
      }export class GetPOsByAgentManuIdError implements Action {
        public readonly type = EPOActions.GetPOsByAgentManuIdError;
        constructor(public payload: any) {

        }
        
      }export class GetPOsByAgentManuId implements Action {
        public readonly type = EPOActions.GetPOsByAgentManuId;
        constructor(public payload: any) {

        }
        
      }
     
        export type POAction = GetAllPOs| GetAllPOsSuccess| GetAllPOsError|GetPOsByStatusId|GetPOsByStatusIdSuccess|
        GetPOsByStatusIdError | AddPO | GetAddPOSuccess | GetAddPOError 
        | EditPO | GetEditPOSuccess | GetEditPOError | GetReceiveMaterialCode | GetReceiveMaterialCodeSuccess |
        GetReceiveMaterialCodeError | AddReceiveMaterial|GetAddReceiveMaterialSuccess | GetAddReceiveMaterialError | 
        GetAllReceivedLOTs|  GetAllReceivedLOTsSuccess | GetAllReceivedLOTsError | EditReceivedLOTs| GetEditReceivedLOTsSuccess | 
        GetEditReceivedLOTsError | GetPONumber | GetPONumberSuccess | GetPONumberError| InActivatePO| GetInActivatePOSuccess|
        GetInActivatePOError|GetPodetailsById|GetPodetailsByIdSuccess| GetPodetailsByIdError
        |GetAllVehicleCondition|GetVehicleConditionSuccess|GetVehicleConditionError
        |StatusMoveToComplete|GetStatusMoveToCompleteSuccess|GetStatusMoveToCompleteError
        | GetCompletePO | GetCompletePOSuccess| GetCompletePOError|GetPOsByAgentManuId|GetPOsByAgentManuIdSuccess|GetPOsByAgentManuIdError;
  
  
  
  
  
  